import { useEffect, useState } from 'react';
import RoleListEdit from './RoleListEdit';
import Pagination from '../../../../common/Pagination';
import { useDispatch } from 'react-redux';
import { getRoleListing } from '../../../../store/slices/RoleUser';
import FullPageLoader from "../../../../common/FullPageLoader";
import AddRolePopup from './AddRolePopup';
import * as HELPER from '../../../../config/helper';
import { ROLE_FEATURES } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";
import { getAgencySalesUsers } from '@src/store/slices/agency';

function RoleListTable(props: any) {
    const dispatch: any = useDispatch();
    let [roleMappingList, setRoleMappingList] = useState<any>([]);
    let [userList, setUserList] = useState<[]>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [showPopup, ShowPopup] = useState(false);
    const [editRoleData, setEditRoleData] = useState({});
    const [loading, setLoading] = useState(false);
    const [showAddRole, setShowAddRole] = useState(false);
    const {translations} = useLanguage();

    const showEditPopUp = (action: boolean, data: any) => {
        ShowPopup(action);
        action ? setEditRoleData(data) : setEditRoleData({});            // set data for edit role popup.
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const getRoleListDetails = async (params: any) => {
        let filters = {
            page_number: params?.page_number ?? 1,
            type: 2
        }
        setLoading(true);
        dispatch(getRoleListing.getRoleData(filters)).then((res: any) => {
            if (res && res.status === 200) {
                setPaginationData({ ...res?.pagination });
                setRoleMappingList([...res?.data]);
            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };

    const getUserListDetails = async (params?: { page_number: number }) => {
        let filters = {
            //page_number: params?.page_number ?? 1
        }
        setLoading(true);
        getAgencySalesUsers(filters).then((res: any) => {
            if (res && res.status === 200) {
                setUserList(res.data);

            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };



    const runPaginationFunc = () => { };
    const handleRequestData = (params: any) => {
        let apiParams = {
            page_number: params.page_no
        }
        getRoleListDetails(apiParams);
    }

    const addNewRole = (action: boolean) => {
        setShowAddRole(action);
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const getApiData = async () => {
        await getRoleListDetails({});
        await getUserListDetails();
    }

    useEffect(() => {
        getApiData();
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <FullPageLoader show={loading} />
            {
                HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit'}) &&
                <div className="add-role-btn">
                            <button className="btn-line" onClick={() => addNewRole(true)}>
                                <span>{translations.RuleEngine?.['Add_Role'] || translations.commonMsg?.loading}</span>
                            </button>
                </div>
            }

            
                <div className="lead-list-data-table role-managment-table-data">
                    <table>
                        <thead>
                            <tr>
                                <th>{translations.RuleEngine?.['Role'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Description'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['User_Assigned'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['status'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['edit'] || translations.commonMsg?.loading}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(roleMappingList && roleMappingList.length > 0) ? roleMappingList.map((row: any, index: number) => {
                                // remove 'My Cases = 35' and 'Assign Lead to User = 34'
                                return (
                                <tr key={index}>
                                    <td>{row.roleName}</td>
                                    <td title={row.description}>{row.description}</td>
                                    <td>{row.user_ids ? row.user_ids.split(",").length : 0} Users</td>
                                    <td><span className={+row.status ? "active-dot" : "inactive-dot"}>{+row.status ? translations.commonMsg?.['active'] || translations.commonMsg?.loading: translations.commonMsg?.['in_active'] || translations.commonMsg?.loading}</span></td>
                                    <td>
                                        <ul className="action-btn">
                                            <li onClick={() => showEditPopUp(true, row)}>
                                                <i className="ic-edit"></i>
                                            </li>
                                        </ul>

                                    </td>
                                </tr>)

                            })
                            :
                            <tr><td colSpan={5} style={{ textAlign: 'center' }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</td></tr>
                            }
                        </tbody>
                    </table>
                    {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                        page: 1,
                        runPaginationFunc,
                        loading: false,
                        tableData: paginationData['limit'],
                        totalLengthWithoutPagination: paginationData['total'],
                        paginationData,
                        filteredData: {}
                    }}
                        sendRequestDataToParent={handleRequestData} />}

                    {showPopup && <RoleListEdit
                        setLoading={setLoading}
                        showPopup={showPopup}
                        editRoleData={editRoleData}
                        roleUserList={userList}
                        getRoleListDetails={(e: any) => getRoleListDetails(e)}
                        showEditPopUp={(e: boolean, data: any) => {
                            showEditPopUp(e, data);
                        }} />}
                    {showAddRole && <AddRolePopup
                        showAddRole={showAddRole}
                        getRoleListDetails={(e: any) => getRoleListDetails(e)}
                        addNewRole={(e: boolean) => {
                            addNewRole(e);
                        }} />}

                </div>

        </>

    )
}

export default RoleListTable

